import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import NavBar from '@src/components/NavBar';
import OurMission from './OurMission';
import BackedBy from './BackedBy';
import TrustlessExecution from './TrustlessExecution';
import UnifiedVerification from './UnifiedVerification';
import UseCases from './UseCases';
import BuildTogether from './BuildTogether';
import Discover from './Discover';
import PageFooter from './PageFooter';
import PageHeader from './PageHeader';
import useAnchor from '@src/hooks/useAnchor';

export default () => {
    const [active, setNavStatus] = useState(false);
    const headerRef = useRef(null);
    useEffect(() => {
        const observer = new IntersectionObserver((enties) => {
            const [entry] = enties;
            setNavStatus(!entry.isIntersecting);
        });
        observer.observe(headerRef.current);
        return () => {
            observer.disconnect();
        }
    }, []);
    useAnchor();
    return (
      <div className={styles.root}>
        <NavBar active={active} />
        <PageHeader ref={headerRef} />
        <BackedBy />
        <TrustlessExecution />
        <UnifiedVerification />
        <BuildTogether />
        <OurMission />
        <UseCases />
        {/* <HowItWorks /> */}

        <Discover />
        <PageFooter />
      </div>
    );
};